import React from "react";
import { BadgeCheck, Clock4, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AboutMainSection = () => {
    const navigate = useNavigate();
    return (
        <section className="about-home-main-section">
            <div className="about-home-content-container">
                {/* Left: Images */}
                <div className="about-home-images-column">
                    <div className="about-home-image about-home-image-top">
                        <img 
                            src="https://armanimakhana.com/2.jpeg" 
                            alt="Armani Makhana Product 1" 
                        />
                    </div>
                    <div className="about-home-image about-home-image-middle">
                        <img 
                            src="https://armanimakhana.com/1.jpeg" 
                            alt="Armani Makhana Product 2" 
                        />
                    </div>
                    <div className="about-home-image about-home-image-bottom">
                        <img 
                            src="https://armanimakhana.com/3.jpeg" 
                            alt="Armani Makhana Product 3" 
                        />
                    </div>
                </div>

                {/* Right: Text */}
                <div className="about-home-text-column">
                    <h2 className="about-home-heading">Armani Roasted Makhana | Gourmet Cheese & Herbs</h2>
                    <p className="about-home-subheading">
                        Elevate your snacking with Armani’s Roasted Makhana. Infused with a rich blend of creamy cheese and aromatic herbs, these fox nuts offer a superior crunch without the grease. High in protein and low in calories, it is the logical choice for those who demand flavor without compromising nutritional integrity.
                        </p>
                    <p className="about-home-subheading">
                        Premium roasted makhana seasoned with savory cheese and herbs. A high-protein, guilt-free snack.
                    </p>

                    <ul className="about-home-features">
                        <li>
                            <BadgeCheck size={20} className="about-home-icon" />
                            The Evolution of Healthy Snacking
                        </li>
                        <li>
                            <Users size={20} className="about-home-icon" />
                            Premium Quality Sourcing
                        </li>
                        <li>
                            <Clock4 size={20} className="about-home-icon" />
                            Roasted, Not Fried
                        </li>
                    </ul>
                <a href="https://armanimakhana.com/product/QXJtYW5pJTIwUm9hc3RlZCUyME1ha2hhbmElMjAlN0MlMjBHb3VybWV0JTIwQ2hlZXNlJTIwJTI2JTIwSGVyYnM=/U1AzNTk=">
                    <button className="about-home-button"  >
                        Shop Now
                    </button>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default AboutMainSection;
